import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import moment from "moment";
import Header from "./Header";
import ContactForm from "./ContactForm";
import loading from "../src/images/loading.gif";
import Footer from "./Footer";
import ChooseUs from "./ChooseUs";
import About from "./About";
import { Helmet } from "react-helmet";
import LocationSelection from "./components/home/LocationSelection";
import TakeawayHighlights from "./components/home/TakeawayHighlights";
import ClassSelectionModal from "./components/home/ClassSelectionModal";
import ClassSelectionStep from "./components/home/modalSteps/ClassSelectionStep";
import InterestsStep from "./components/home/modalSteps/InterestsStep";
import GuestInviteStep from "./components/home/modalSteps/GuestInviteStep";
import GuestDetailsStep from "./components/home/modalSteps/GuestDetailsStep";

const investingInterestOptions = [
  "Create the right asset protection strategy to protect your wealth",
  "Find off-market discounted properties and access deals most investors never see",
  "Flip houses without using your own money and profit without tying up your capital",
  "Buy turnkey rentals to earn consistent passive income",
  "Invest in multifamily properties (20+ units) and scale wealth through apartments",
];

const initialGuestFormState = {
  fname: "",
  lname: "",
  email: "",
  phone: "",
};

function Home() {
  const [sheetData, setSheetData] = useState(null);
  const [innerData, setInnerData] = useState();
  const [firstChild, setFirstChild] = useState();
  const [selectChild, setSelectChild] = useState(null);
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    number: '',
    selectedTime: null,
    interests: [],
    guestPreference: null,
    guest: null,
    selectedClass: null,
  });
  const [showClassModal, setShowClassModal] = useState(false);
  const [modalStep, setModalStep] = useState("select");
  const [selectedClassOptionId, setSelectedClassOptionId] = useState(null);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [guestPreference, setGuestPreference] = useState(null);
const [guestForm, setGuestForm] = useState({
  fname: '',
  lname: '',
  email: '',
  phone: '',
});

const [guestFormErrors, setGuestFormErrors] = useState({
  fname: '',
  lname: '',
  email: '',
  phone: '',
});

const handleGuestChange = (field, value) => {
  setGuestForm((prev) => ({ ...prev, [field]: value }));

  // Clear or re-validate single field
  setGuestFormErrors((prevErrors) => {
    const newErrors = { ...prevErrors };

    if (field === "email") {
      if (!/\S+@\S+\.\S+/.test(value)) {
        newErrors.email = "Invalid email address";
      } else {
        newErrors.email = "";
      }
    }

    if (field === "phone") {
      if (value.trim() === "") {
        newErrors.phone = "Phone number is required";
      } else if (value.length !== 12) {
        newErrors.phone = "Correct phone number is required";
      } else {
        newErrors.phone = "";
      }
    }

    if (field === "fname" && value.trim() !== "") {
      newErrors.fname = "";
    }

    if (field === "lname" && value.trim() !== "") {
      newErrors.lname = "";
    }

    return newErrors;
  });
};


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const locationParam = urlParams.get("loc");

    if (locationParam === null) {
      return;
    }

    const parsedIndex = Number(locationParam);
    setSelectChild(Number.isNaN(parsedIndex) ? locationParam : parsedIndex);
  }, []);



  useEffect(() => {
    axios
      .get("https://lp.taxliensuccess.com/sheetData")
      .then((response) => {
        const locations = Object.entries(response.data || {}).map(([key, value]) => ({
          key,
          value,
        }));
        setSheetData(locations);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (!Array.isArray(sheetData) || sheetData.length === 0) {
      return;
    }

    if (selectChild === null || selectChild === undefined || selectChild === "") {
      return;
    }

    let resolvedSelection = null;

    if (typeof selectChild === "number" && selectChild >= 0 && selectChild < sheetData.length) {
      resolvedSelection = sheetData[selectChild];
    } else if (typeof selectChild === "string") {
      resolvedSelection = sheetData.find((item) => item.key === selectChild) || null;
    }

    if (!resolvedSelection) {
      return;
    }

    setFirstChild(resolvedSelection.key);
    setInnerData(resolvedSelection);
  }, [sheetData, selectChild]);

  useEffect(() => {
    if (!sheetData) {
      const timeout = setTimeout(() => {

        window.location.reload(); // Refresh the page
      }, 10000);

      return () => {
        clearTimeout(timeout); // Clear the timeout when the component unmounts
      };
    }
  }, [sheetData]);

  useEffect(() => {
    if (!showClassModal) {
      setModalStep("select");
    }
  }, [showClassModal]);

  useEffect(() => {
    if (modalStep === "interests" && selectedInterests.length === 0 && formData.interests?.length) {
      setSelectedInterests(formData.interests);
    }
    if (modalStep === "guestInvite" && !guestPreference && formData.guestPreference) {
      setGuestPreference(formData.guestPreference);
    }
    if (
      modalStep === "guestDetails" &&
      formData.guest &&
      !guestForm.fname &&
      !guestForm.lname &&
      !guestForm.email &&
      !guestForm.phone
    ) {
      setGuestForm(formData.guest);
    }
  }, [modalStep, selectedInterests.length, formData.interests, formData.guestPreference, formData.guest, guestPreference, guestForm.fname, guestForm.lname, guestForm.email, guestForm.phone]);

 const classOptions = useMemo(() => {
  if (!innerData?.value?.length) return [];


  const options = [];

  innerData.value.forEach((classItem, classIdx) => {
    const dayName = new Date(classItem.date).toLocaleDateString(
      "en-US",
      { weekday: "long" }
    );

    const city = classItem.city;

    const timeSlots = Array.isArray(classItem.time)
      ? classItem.time.filter(Boolean)
      : [classItem.time].filter(Boolean);

    if (timeSlots.length === 0) {
      options.push({
        optionId: `${classIdx}-0`,
        classItem,
        time: null,
        dayName,
        city,
      });
    } else {
      timeSlots.forEach((timeValue, timeIdx) => {
        options.push({
          optionId: `${classIdx}-${timeIdx}`,
          classItem,
          time: timeValue,
          dayName,
          city,
        });
      });
    }
  });
console.log("classOptions:", options);
  return options;
}, [innerData]);


 const formatClassLabel = (classItem, timeOverride, dayName, city) => {
  if (!classItem) return "Date to be announced";

  const parsedDate = moment(classItem.date, ["MMMM Do YYYY", "MMMM D YYYY"]);
  const dateLabel = parsedDate.isValid()
    ? parsedDate.format("MMMM Do")
    : classItem.date || "Date to be announced";

  const timeLabel = timeOverride
    ? timeOverride
    : Array.isArray(classItem.time)
      ? classItem.time.find(Boolean) || ""
      : classItem.time || "";

  const zoneLabel = classItem.timezone || classItem.timeZone || "";
  const dayLabel = dayName || "";
  const cityLabel = city || "";

  return [dayLabel, dateLabel, timeLabel, zoneLabel, cityLabel]
    .filter(Boolean)
    .join(", ");
};


  const handleClassModalClose = () => {
    setShowClassModal(false);
    setModalStep("select");
    setSelectedClassOptionId(null);
    setSelectedInterests([]);
    setGuestPreference(null);
    setGuestForm(initialGuestFormState);
    setGuestFormErrors({});
  };

  const handleClassSelect = (selectedOption) => {
    if (!selectedOption) {
      return;
    }

    const { classItem, time } = selectedOption;
    const parsedDate = moment(classItem?.date, ["MMMM Do YYYY", "MMMM D YYYY"]);
    const formattedDate = parsedDate.isValid()
      ? parsedDate.format("YYYY-MM-DD")
      : classItem?.date;
    const dayName = parsedDate.isValid() ? parsedDate.format("dddd") : "";
    const dateLabel = parsedDate.isValid()
      ? parsedDate.format("MMMM Do")
      : classItem?.date || "Date to be announced";
    const zoneLabel = classItem?.timezone || classItem?.timeZone || "";
    const locationName = innerData?.key || "";

    setFormData((prevData) => ({
      ...prevData,
      selectedTime: time ?? null,
      selectedClass: {
        ...classItem,
        time: time ?? "",
        formattedDate,
        dayName,
        dateLabel,
        zoneLabel,
        locationName,
      },
    }));

    setModalStep("contact");
  };

  const handleClassOptionSelect = (optionId) => {
    setSelectedClassOptionId(optionId);
    const option = classOptions.find((item) => item.optionId === optionId);
    if (option) {
      handleClassSelect(option);
    }
  };

  const handleModalBack = () => {
    setModalStep("select");
  };

  const handleClassConfirm = () => {
    if (!selectedClassOptionId) {
      return;
    }
    const option = classOptions.find((item) => item.optionId === selectedClassOptionId);
    if (option) {
      handleClassSelect(option);
    }
  };

  const toggleInterest = (interest) => {
    console.log("Clicked:", interest);
    setSelectedInterests((prevInterests) => {
      const updated = prevInterests.includes(interest)
        ? prevInterests.filter((i) => i !== interest)
        : [...prevInterests, interest];

      setFormData((prev) => ({
        ...prev,
        interests: updated,
      }));

      return updated;
    });
  };

    const handleInterestsNext = async () => {
      let valid = true;
    setFormData((prevData) => ({
      ...prevData,
      interests: selectedInterests,
    }));
     const finalData = {
      ...formData,
      interests: selectedInterests,
    };
     const dateStr = formData.selectedClass.date;
    const dateObj = moment(dateStr, "MMMM Do YYYY");
    const newdateName = dateObj.format("DD"); // e.g. "Monday"
    const newmonthName = dateObj.format("MMMM"); // e.g. "February"
    console.log("prev data with interest", finalData);
     const updatedInterestedFormValues = {
      fname: formData.fname,
      lname: formData.lname,
      email: formData.email,
      number: formData.number, 
      dateName: newdateName,
      monthName: newmonthName,
      dateStr: formData.dateStr,
      dayName: formData.dayName,
      selectedOption: formData.startTime,
      startTime: formData.startTime,
      endTime: formData.endTime,
      formattedDate: formData.formattedDate,
      hotel: formData.hotel,
      street: formData.street,
      lobyName: formData.lobyName,
      city: formData.city,
      zipcode: formData.zipcode,
      state: formData.state,
      hotelPhone: formData.hotelPhone,
      campaign: formData.campaign,
      utmSource: formData.utmSource,
      utmMedium: formData.utmMedium,
      utmCampaign: formData.utmCampaign,
      locationName: formData.locationName,
      interests: formData.interests,
    };
    console.log("updatedInterestedFormValues:", updatedInterestedFormValues);
    if (valid) {
      const response = await fetch('https://services.leadconnectorhq.com/hooks/kJOiQyFsJQQj5rYEbrCO/webhook-trigger/GYnUsPXpYZ4S6o6NVno1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedInterestedFormValues)
      });

      if (response.ok) {
           setModalStep("guestInvite");
      } else {
        console.log("response field")

      }
    } 


  };

  const handleGuestPreferenceChange = (value) => {
    setGuestPreference(value);
  };

  const completeRegistration = (additionalData = {}) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        interests: selectedInterests,
        guestPreference: guestPreference,
        guest: guestPreference === "yes" ? guestForm : null,
        ...additionalData,
      };
      return updatedData;
    });
    setShowClassModal(false);
    setModalStep("select");
    setSelectedClassOptionId(null);
    setSelectedInterests([]);
    setGuestPreference(null);
    setGuestForm(initialGuestFormState);
    setGuestFormErrors({});
  };

  const handleGuestPreferenceNext = () => {
    setFormData((prev) => ({
      ...prev,
      guestPreference,
    }));

    if (guestPreference === "yes") {
      setModalStep("guestDetails");
    } else {
      completeRegistration();
    }
  };

  const handleGuestFormSubmit = async (e) => {

    e.preventDefault();
    console.log("guestData", e);
    console.log("guestForm", guestForm);
    const finalData = {
      ...formData,
      guest: guestForm,
    };
    console.log("Final submission data:", finalData);
    // return;
    let valid = true;
    const errors = {};
    // Validate First Name
  if (!guestForm.fname.trim()) {
    errors.fname = "First name is required";
    valid = false;
  }

  // Validate Last Name
  if (!guestForm.lname.trim()) {
    errors.lname = "Last name is required";
    valid = false;
  }

  // Validate Email
  if (!guestForm.email.trim()) {
    errors.email = "Email is required";
    valid = false;
  } else if (!/\S+@\S+\.\S+/.test(guestForm.email)) {
    errors.email = "Email is invalid";
    valid = false;
  } else if (formData.email === guestForm.email) {
    errors.email = "This email is already being used, please use guest email.";
    valid = false;
  }

  // Validate Phone
  if (!guestForm.phone.trim()) {
    errors.phone = "Phone number is required";
    valid = false;
  } else if (formData.number === guestForm.phone) {
    errors.phone = "This number is already being used, please use guest number.";
    valid = false;
  }

  setGuestFormErrors(errors);

  if (!valid) return; 

    const dateStr = formData.selectedClass.date;
    console.log("dateStr", dateStr);
    // Use Moment.js to parse the date string and format it
    const dateObj = moment(dateStr, "MMMM Do YYYY");
    const newdateName = dateObj.format("DD"); // e.g. "Monday"
    const newmonthName = dateObj.format("MMMM"); // e.g. "February" 
    setGuestFormErrors(errors);
    const updatedGuestFormValues = {
      guestFirstName: guestForm.fname,
      guestLastName: guestForm.lname,
      guestEmail: guestForm.email,
      guestNumber: guestForm.phone,
      primaryContactFirstName: formData.fname,
      primaryContactLastName: formData.lname,
      primaryContactEmail: formData.email,
      dateName: newdateName,
      monthName: newmonthName,
      dateStr: formData.dateStr,
      dayName: formData.dayName,
      selectedOption: formData.startTime,
      startTime: formData.startTime,
      endTime: formData.endTime,
      formattedDate: formData.formattedDate,
      hotel: formData.hotel,
      street: formData.street,
      lobyName: formData.lobyName,
      city: formData.city,
      zipcode: formData.zipcode,
      state: formData.state,
      hotelPhone: formData.hotelPhone,
      campaign: formData.campaign,
      utmSource: formData.utmSource,
      utmMedium: formData.utmMedium,
      utmCampaign: formData.utmCampaign,
      locationName: formData.locationName,
      interests: formData.interests,

    };
    console.log("updatedGuestFormValues:", updatedGuestFormValues);
    if (valid) {
      const response = await fetch('https://services.leadconnectorhq.com/hooks/kJOiQyFsJQQj5rYEbrCO/webhook-trigger/51yyBlDZwwlx5o3vqFt0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedGuestFormValues)
      });

      if (response.ok) {
        // Code to handle successful form submission goes here
        window.location.replace('/thanks');
      } else {
        // Code to handle form submission error goes here
      }
    } else {
      setGuestFormErrors(errors);
    }

  };

  const renderModalBody = () => {
    if (modalStep === "select") {
      return (
        <ClassSelectionStep
          classOptions={classOptions}
          selectedOptionId={selectedClassOptionId}
          onSelectOption={handleClassOptionSelect}
          formatLabel={formatClassLabel}
        />
      );
    }

    if (modalStep === "contact") {
      return (
        <div className="class-modal-contact">
          <ContactForm
            onSubmit={handleContactSubmit}
            initialData={formData}
            showTimeField={false}
            onBack={handleModalBack}
            continueLabel="Next"
            showNavigation
          />
        </div>
      );
    }

    if (modalStep === "interests") {
      return (
        <InterestsStep
          options={investingInterestOptions}
          selected={selectedInterests}
          onToggle={toggleInterest}
          onBack={() => setModalStep("contact")}
          onNext={handleInterestsNext}
        />
      );
    }

    if (modalStep === "guestInvite") {
      return (
        <GuestInviteStep
          preference={guestPreference}
          onChange={handleGuestPreferenceChange}
          onBack={() => setModalStep("interests")}
          onNext={handleGuestPreferenceNext}
        />
      );
    }

    if (modalStep === "guestDetails") {
      return (
        <GuestDetailsStep
          guest={guestForm}
          errors={guestFormErrors}
          onChange={handleGuestChange}
          onBack={() => setModalStep("guestInvite")}
          onSubmit={handleGuestFormSubmit}
        />
      );
    }

    return null;
  };

  // Installation script generated by Ad Analytics
  const adScript = `
(function(w, d){
var id='spdt-capture', n='script';
if (!d.getElementById(id)) {
w.spdt =
w.spdt ||
function() {
(w.spdt.q = w.spdt.q || []).push(arguments);
};
var e = d.createElement(n); e.id = id; e.async=1;
e.src = 'https://pixel.byspotify.com/ping.min.js';
var s = d.getElementsByTagName(n)[0];
s.parentNode.insertBefore(e, s);
}
w.spdt('conf', { key: 'a9d12a39cf7e41c0b0273e19eef95df8' });
w.spdt('view');
})(window, document);
`;
  const handleContactSubmit = (data) => {
    console.log("aaa", data);
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
    setModalStep("interests");
  };

  const handleLocationSelect = (item) => {
localStorage.setItem('selectedClassDetails', JSON.stringify(item));

    console.log("item", item);
    setInnerData(item);
    setFirstChild(item.key);
    setSelectedClassOptionId(null);
    setModalStep("select");
    setSelectedInterests([]);
    setGuestPreference(null);
    setGuestForm(initialGuestFormState);
    setGuestFormErrors({});
    if (item?.value?.length) {
      setShowClassModal(true);
    } else {
      setShowClassModal(false);
    }
  };
  // when a class (Calendar) is selected
  return (
    <div>
      <Helmet>
        {/* <!-- Facebook Pixel Code --> */}

        <script>{`
       !function(f,b,e,v,n,t,s)
       {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
       n.callMethod.apply(n,arguments):n.queue.push(arguments)};
       if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
       n.queue=[];t=b.createElement(e);t.async=!0;
       t.src=v;s=b.getElementsByTagName(e)[0];
       s.parentNode.insertBefore(t,s)}(window, document,'script',
       'https://connect.facebook.net/en_US/fbevents.js');
       fbq('init', '1257597491944293');
       fbq('track', 'PageView');       
        `}</script>
        {/* <!-- clarity Code --> */}

        <script>{`
       (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "h60ub7uev3");       
        `}</script>

        {/* <!-- nudgify Code --> */}

        <script>{`
         (function(w){
          var k="nudgify",n=w[k]||(w[k]={});
          n.uuid="188c3d46-5f4e-4a8d-9806-e440faedad89";
          var d=document,s=d.createElement("script");
          s.src="https://pixel.nudgify.com/pixel.js";
          s.async=1;
          s.charset="utf-8";
          d.getElementsByTagName("head")[0].appendChild(s)
      })(window)   
        `}</script>
        {/* <!-- Tik Tok Code --> */}

        <script>{`
         !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        
          ttq.load('CFUH7KBC77U840VNCFO0');
          ttq.page();
        }(window, document, 'ttq'); 
        `}</script>
        {/* <!-- Google tag (gtag.js) --> */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-630361343"></script>
        <script>
          {` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-630361343');`}
        </script>


        {/* // Installation script generated by Ad Analytics */}


        <script>{adScript}</script>

      </Helmet>

      <div className="confirm-btn-clss">
        <img
          src="https://strategicmedia-23-adswizz.attribution.adswizz.com/fire?pixelId=ad9ff7b3-e6f3-4563-92af-299a17659f3c&type=sitevisit&subtype=PageVisit1&aw_0_req.gdpr=true&redirectURL=aHR0cHM6Ly9waXhlbC50YXBhZC5jb20vaWRzeW5jL2V4L3JlY2VpdmU_cGFydG5lcl9pZD0yOTk0JjwjaWYgcmVxdWVzdC5saXN0ZW5lcklkP21hdGNoZXMoJ1swLTlhLWZdezh9LVswLTlhLWZdezR9LVswLTlhLWZdezR9LVswLTlhLWZdezR9LVswLTlhLWZdezEyfScpPnBhcnRuZXJfdHlwZWRfZGlkPSU3QiUyMkhBUkRXQVJFX0FORFJPSURfQURfSUQlMjIlM0ElMjIke3JlcXVlc3QubGlzdGVuZXJJZH0lMjIlN0Q8I2Vsc2VpZiByZXF1ZXN0Lmxpc3RlbmVySWQ_bWF0Y2hlcygnWzAtOUEtRl17OH0tWzAtOUEtRl17NH0tWzAtOUEtRl17NH0tWzAtOUEtRl17NH0tWzAtOUEtRl17MTJ9Jyk-cGFydG5lcl90eXBlZF9kaWQ9JTdCJTIySEFSRFdBUkVfSURGQSUyMiUzQSUyMiR7cmVxdWVzdC5saXN0ZW5lcklkfSUyMiU3RDwjZWxzZT5wYXJ0bmVyX2RldmljZV9pZD0ke3JlcXVlc3QubGlzdGVuZXJJZCF9PC8jaWY-"
          alt="Tracking pixel"
        />

      </div>

      <div>
        <Header />
      </div>





      <section className="section-one" id="mySection">
        <div className="container ">
          <div className="top-heading">
            <h2>Free In-Person Workshop Reveals How To:
            </h2>
            <h1>Find, Flip & <span>PROFIT</span>
            </h1>
            <h3>From Your Next or First Deal <span>LIVE!</span>
            </h3>
            <h4>Discover: How in just two hours you can <u>find high-profit deals</u> before the competition, and <u>build lasting wealth!</u>

            </h4>

          </div>

          <div className="form-section-main" >
            <LocationSelection
              locations={sheetData}
              activeLocation={firstChild}
              onSelectLocation={handleLocationSelect}
              loadingSrc={loading}
            />
            <TakeawayHighlights />
          </div>
        </div>
      </section>
      <ClassSelectionModal
        show={showClassModal}
        step={modalStep}
        onHide={handleClassModalClose}
        onConfirm={handleClassConfirm}
        canConfirm={Boolean(selectedClassOptionId && classOptions.length)}
      >
        {renderModalBody()}
      </ClassSelectionModal>
      <div className="choose-us">
        <ChooseUs />
      </div>
      <About />
      <Footer />
    </div>
  );
}

export default Home;









